import { numericScore, qualitativeScoreLabel } from './scoreLabel';

/**
 * ✅ LIGHTWEIGHT MAP UTILS
 * No heavy dependencies (like pdf-lib) allowed here.
 */
export const countryCentroids: Record<string, [number, number]> = {
    "AFG": [67.709953, 33.93911],
    "KEN": [37.906193, -0.023559],
    "USA": [-95.712891, 37.09024],
    "UKR": [31.16558, 48.379433],
    "ISR": [34.851612, 31.046051],
    "TWN": [120.960515, 23.69781],
};

/**
 * Standardizes risk scores to a 100-point scale.
 * Detects legacy 0-10 scores and scales them.
 */
export const normalizeRiskScore = (score: number | null | undefined): number => {
    if (score === null || score === undefined) return 0;
    // Removed legacy scaling. Routed models use 0-100 natively.
    return Math.round(score);
};

export const getRiskHexColor = (score: unknown): string => {
    const s = numericScore(score);
    if (s === null) {
        const label = qualitativeScoreLabel([score]);
        return label === 'CRITICAL' ? '#8B0000' : label === 'HIGH' || label === 'VERY HIGH' ? '#FF4500'
            : label === 'MEDIUM' || label === 'MODERATE' ? '#FFA500' : label === 'LOW' ? '#008000' : '#E0E0E0';
    }

    if (s >= 80) return '#8B0000'; // Critical
    if (s >= 60) return '#FF4500'; // High
    if (s >= 40) return '#FFA500'; // Medium
    return '#008000'; // Low
};
